import * as React from "react";
import { useState } from "react";
import { urbanistyka } from "./Data";
import "./Cards.css";
import Counter2 from "./Counter2";

export default function MediaCard() {
  const [card, setCard] = useState(-1);
  var myArray = urbanistyka;
  var rand = myArray[(Math.random() * myArray.length) | 0];

  const nextCardOnClick = () => {
    setCard((prev) => (prev + 1) % 3);
  };

  return (
    <div className="card">
      <h4 className="title">URBANISTYKA</h4>
      <p>{rand}</p>
      <div className="buttons">
        <Counter2 />
        <button className="btn" onClick={nextCardOnClick}>
          Następne pytanie
        </button>
      </div>
    </div>
  );
}
